import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class CountryService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/pais', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/pais/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {

    try {
      return await axios.post('pais/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/pais/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/pais/' + id);
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/country.js